module.exports = __webpack_public_path__ + "img/logo.6df10c8d.png";